import { IncomingMailDTO } from "../../models/incoming-mail/incoming-mail-dto";
import { IncomingMailSTO } from "../../models/incoming-mail/incoming-mail-sto";
import { BaseApiService } from "../base";

export class IncomingMailApiService extends BaseApiService<IncomingMailDTO, IncomingMailSTO> {
  constructor() {
    super({
      servicePath: "/IncomingMail",
      loadItemsPath: "/GetIncomingMails",
      saveItemsPath: "/SaveIncomingMails",
    });
  }
}
